// Module-scoped bridge so a DIALOG can open the My Event editor.
//
// agenda.vue provides `openMyEvent` for the cards inside its own tree, but a
// modal opened through useModal() mounts near the app root — it is NOT a
// descendant, so `inject('openMyEvent')` there returns null SILENTLY and the
// click reads as a dead link. See the double-book conflict link.
//
// A plain module-scoped ref works because the opener is a function: it must NOT
// live in useState(), which would try to serialize it into the SSR payload.
// The registrant owns cleanup, so a second agenda mount can't leave a stale
// opener pointing at an unmounted component.
const opener = { fn: null };

export const useMyEventOpener = () => {
    // Called by the agenda on mount; returns an unregister for onScopeDispose.
    const registerMyEventOpener = (fn) => {
        opener.fn = fn;
        return () => { if (opener.fn === fn) opener.fn = null; };
    };

    const hasMyEventOpener = () => typeof opener.fn === 'function';

    // Resolves when the editor closes, so callers can conceal-and-return.
    // Returns false when nothing is registered — the caller decides what a
    // no-op means rather than silently doing nothing.
    const openMyEventFromDialog = async (rawEvent) => {
        if (!hasMyEventOpener()) return false;
        await opener.fn(rawEvent);
        return true;
    };

    return { registerMyEventOpener, hasMyEventOpener, openMyEventFromDialog };
};
